import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { Observable } from "rxjs";
import { PublicLocation } from "../../domain/models";
import { Injectable } from "@angular/core";
import { PublicLocationRequest } from "../../domain/requests/public-location-request";

@Injectable({providedIn: 'root'})
export class GetPublicLocationsUsecase implements UseCase<PublicLocationRequest, PublicLocation[]> {
  constructor(private locationRepository: LocationsRepository) {
  }

  execute(request: PublicLocationRequest): Observable<PublicLocation[]> {
    return this.locationRepository.getPublicLocations(request);
  }
}
